<!-- Navbar start -->

<div style="position:relative; z-index: 100; width: 100%;    ">
<nav class="navbar navbar-expand-md fixed-top py-0 top-0">
  <div class="container">
    <a class="navbar-brand " href="#"><img class="img-fluid lozad" src="assets/img/logo.png"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
      

         <li class="nav-item">
    <a class="nav-link" [routerLink]="['']">Home</a>
  </li>

  
   <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages/network/index.html"
      >Network</a
    >
  </li>
   <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/home/index.html"
      >Hub</a
    >
  </li>

  <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/bio/index.html"
      >Bio</a
    >
  </li>
  <li class="nav-item">
          <a class="nav-link" [routerLink]="['/services']">Type of services</a>
        </li>

         <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/cf']"
                  >Card Features</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/package']"
                  >View Services</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/ai']"
                  >Additional Features</a
                >
              </li>
      </ul>
    </div>
  </div>
</nav>
</div>
  <!-- Navbar End -->
<section class="bg-light py-5 service-section" style="margin-top: 100px;">
  <div class="container">

    <!-- SONG REGISTRATION SERVICES -->
    <div class="mb-5 text-center">
      <div class="mx-auto" style="max-width: 900px;">
        <h2 class="mb-3 fw-bold">🎵 Song Registration Services</h2>
        <p>Get your music properly registered and ensure you're receiving royalties from<strong> BMI, ASCAP, The MLC, and SoundExchange.</strong><br> Whether starting out or managing a full catalog, we've got you covered.</p>
        <button class="btn btn-primary">Read More</button>
      </div>

      <div class="container" style="max-width: 900px;">
        <h2 class="text-center mb-3 mt-5 " data-aos="fade-up">💡 Why This Matters for Artists</h2>
        <p class="text-center mb-0" data-aos="fade-up">
          If your songs aren’t registered with the right organizations, you’re leaving money on the table.
        </p>
        <p class="text-center mb-0" data-aos="fade-up">
          Every time your music is streamed, performed, or broadcasted, you’re owed royalties.
        </p>
        <p class="text-center mb-4 " data-aos="fade-up">
          These services ensure you’re set up to collect every dollar.
        </p>
      </div>

      <h4 class="fw-bold mb-4 text-start">📦 Choose Your Tier</h4>
        <div class="row">
          <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>Tier 1: 11–50 songs – $350</li>
                  <li>Tier 2: 51–300 songs – $600</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-4" data-aos="flip-left">
            <div class="welcome text-start">
              <h2>Included Services:</h2>
              <ul class="ps-0">
                <li class="">PRO registration (BMI or ASCAP)</li>
                <li class="">MLC & SoundExchange registration</li>
                <li class="">Metadata verification</li>
                <li class="">Final registration report</li>
              </ul>
            </div>
          </div>
        </div>
      <p><strong>Payment Methods:</strong> Cash App: $Zaecepe | Zelle: zae&#64;zaecepe.com</p>
      <p><em>Include: "Song Registration – Tier 1" or "Tier 2" in payment note</em></p>
    </div>
  </div>
</section>

<section class="pledge py-5 service-section">
  <div class="container">
    <!-- MUSIC VIDEO SERVICES -->
    <div class="">
      <div class="container text-center text-white" style="max-width: 900px;">
        <h2 class="mb-3 text-semibold">🎬 Music Video Shoot & Editing Services</h2>
        <p >Bring your vision to life with high-quality visuals tailored for your brand and budget.<br>Whether you’re just starting or ready to go all-out—there’s a package for you.</p>
        <button class="btn btn-light">Read More</button>

        <h2 class="text-center mb-3 mt-5 " data-aos="fade-up">Why this matters for artist</h2>
        <p class="text-center mb-0" data-aos="fade-up">
          A professional music video isn’t just content—it’s your <strong>visual identity, a marketing tool, and a first impression.</strong>
        </p>
        <p class="text-center mb-4 " data-aos="fade-up">
          The right video helps you stand out, connect with fans, and elevate your artistry.
        </p>
      </div>


      <h4 class="fw-semibold mb-4 text-white">Choose Your Package</h4>
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <h4 class="card-title">Basic – $350</h4>
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>1-hour shoot</li>
                  <li>1 location</li>
                  <li>1080p edited</li>
                  <li>1 revision</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <h4 class="card-title">Standard – $400</h4>
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>2–3 hour shoot</li>
                  <li>Up to 2 locations</li>
                  <li>Color correction</li>
                  <li>2 revisions</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <h4 class="card-title">Premium – $600</h4>
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>Half-day shoot</li>
                  <li>Up to 3 locations</li>
                  <li>Direction & creative support</li>
                  <li>Color grading</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-4 mt-5" data-aos="flip-left">
            <div class="welcome">
              <h2 class="text-white mb-4">ADD-ONS</h2>
              <ul class="ps-0">
                <li class="">4K Output – +$100</li>
                <li class="">Extra Shooting Hour – +$75/hour</li>
                <li class="">Extra Revisions – +$30 each</li>
                <li class="">Rush Delivery (48 hrs) – +$100</li>
              </ul>
            </div>
          </div>
        </div>
      <div class="text-white text-center">
         <p><strong>Payment:</strong> Cash App: $Zaecepe | Zelle: zae&#64;zaecepe.com</p>
         <p><em>Include: "Music Video – [Package Name]"</em></p>
      </div>
    </div>
  </div>
</section>

<section class="bg-light py-5 service-section">
  <div class="container">
    <!-- VIDEO ADS & PROMOS -->
    <div class="mb-5">
      <div class="mx-auto text-center" style="max-width: 900px;">
      <h2 class="mb-3 fw-semibold">📢 Video Ads & Promo Services</h2>
      <p><strong>Capture attention. Drive results. Grow your brand.</strong></p>
      <p> From whiteboard animations to live video and 3D characters—we create compelling content that gets your message across and delivers ROI.</p>
      </div>
      <div class="welcome">
        <h4 class="fw-bold">Perfect For:</h4>
        <ul class="ps-0">
          <li class="">Small Businesses</li>
          <li class="">Entrepreneurs</li>
          <li class="">Product Launches</li>
          <li class="">Local Events</li>
          <li class="">Social Media Campaigns</li>
          <li class="">YouTube/Facebook/Instagram Ads</li>
        </ul>
      </div>

      <div class="container" style="max-width: 900px;">
        <h2 class="text-center mb-3 mt-5 " data-aos="fade-up">Why this Matters for Your Brand</h2>
        <p class="text-center mb-0" data-aos="fade-up">
          In today’s world, video is more than just entertainment—it's the most powerful marketing tool available.
        </p>
        <p class="text-center mb-4 " data-aos="fade-up">
          Engaging video ads increase conversions, boost brand awareness, and connect with your target audience instantly.
        </p>
      </div>

        <div class="row justify-content-center">
          <div class="col-md-8 mb-4" data-aos="flip-left">
            <h4 class="fw-bold mb-4 ">Choose Your Package</h4>
            
          </div>
          <div class="col-md-8 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <h4 class="card-title">Basic – $250</h4>
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>30–60 second whiteboard or 2D explainer video</li>
                  <li>Script assistance (client provides main content)</li>
                  <li> Royalty-free background music</li>
                  <li>720p video, 1 revision</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-8 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <h4 class="card-title">Standard – $400</h4>
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>60–90 second animated or live footage promo</li>
                  <li>Script writing included</li>
                  <li>Voiceover (1 language/accent)</li>
                  <li>Logo animation</li>
                  <li>Color grading / Brand matching</li>
                  <li>1080p, 2 revisions</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-8 mb-4" data-aos="flip-left">
            <div class="membership-cards h-100 shadow rounded-4">
              <div class="card h-100 p-3">
                <h4 class="card-title">Premium – $650</h4>
                <ul class="list-unstyled ps-3 my-3 text-start">
                  <li>Up to 2-minute custom video (2D/3D animation, whiteboard or hybrid)</li>
                  <li>Full scriptwriting and creative direction</li>
                  <li>Voiceover with SFX</li>
                  <li>Stock footage & animation</li>
                  <li>3 revisions</li>
                  <li>Includes one format optimized for social media (Instagram, TikTok, etc.)</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-8 mb-4 mt-5" data-aos="fade-up">
            <div class="welcome">
              <h2 class="mb-4">ADD-ONS</h2>
              <ul class="ps-0">
                <li class="">4K Output – +$100</li>
                <li class="">Extra Revision – +$30 each</li>
                <li class="">Rush Delivery (72 hrs) – +$125</li>
                <li class="">Custom 3D Character/Scene – +$150</li>
                <li class="">Multi-format Delivery – +$50</li>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </div>
</section>

<section class="pledge py-5 service-section">
  <div class="container">
    <!-- BUSINESS PROMO BUNDLES -->
    <div class="mb-5">
      <h2 class="mb-5 text-center text-white">📈 Full-Service Business Promo Bundles</h2>
      <div class="row ">
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Starter Growth Pack – $850</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>1 Standard Promo Video (60–90 sec)</li>
                <li>SEO Optimization for 3 pages</li>
                <li>Social Media Setup + 2 Branded Templates</li>
                <li>Business Contact List (Up to 200 leads, B2B or B2C)</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Digital Business Builder – $1,500</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>1 Premium Promo Video</li>
                <li>Basic Website (up to 5 pages)</li>
                <li>Web Hosting (1st Year Free)</li>
                <li>Email/Video Blast to 1,000 Contacts</li>
                <li>Social Media Management (30 days, 3 platforms)</li>
                <li>Direct Mail Postcard Design (printing not included)</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Ultimate Growth Machine – $2,800</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>2 Custom Promo Videos</li>
                <li>App UI Mockup + Landing Page</li>
                <li>Lead Gen Contact List (Up to 1,000 leads)</li>
                <li>Direct Mail Postcard Campaign (design + list)</li>
                <li> 2 Months Social Media Management</li>
                <li>Monthly Email Marketing Setup</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center text-white mt-5">
        <p><strong>Payment Methods:</strong> Cash App: $Zaecepe | Zelle: zae&#64;zaecepe.com</p>
        <p><em>Include: "Promo Video – [Package Name]"</em></p>
      </div>
    </div>
  </div>
</section>

<section class="bg-light py-5 service-section">
  <div class="container">

    <!-- VIDEO CREATION SERVICES -->
    <div class="mb-5">
      <h2 class="mb-5 fw-semibold text-center">🎞️ Video Creation Services</h2>
      <div class="row">
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Whiteboard Animation</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Up to 60 sec – $150</li>
                <li>60–90 sec – $200</li>
                <li>90–120 sec – $250</li>
              </ul>
              <p class="fw-semibold"> Add-ons: Voiceover +$50, Scriptwriting +$40</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">2D Character Animation</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Up to 60 sec – $200</li>
                <li>60–90 sec – $275</li>
                <li>90–120 sec – $325</li>
              </ul>
              <p class="fw-semibold">Add-ons: Custom character +$50 each</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">3D Character/Scene Animation</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>30–60 sec – $300</li>
                <li> 60–90 sec – $400</li>
                <li>Custom Full Scene/Brand Animation – From $600+</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Live-Action Video Editing</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Basic Cut + Music – $125</li>
                <li>With Motion Graphics & Transitions – $200</li>
                <li>Full Branding (Logo, Lower Thirds, CTA) – $250+</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Promo Video Production</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li> Local Shoot (1-hour, 1 location) – $300</li>
                <li>Half-day Shoot (Up to 3 locations) – $500</li>
                <li> Full-day Custom Production – $800+</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pledge py-5 service-section">
  <div class="container">

    <!-- DIGITAL MARKETING & SEO -->
    <div class="mb-5 ">
      <div class="welcome">
        <h2 class="mb-4 fw-semibold text-white">🌐 Digital Marketing & SEO Services</h2>
        <ul class="ps-0">
          <li class="">Basic SEO (3 pages): $150–$200</li>
          <li class="">Full Site SEO (10 pages): $290–$450</li>
          <li class="">Monthly SEO Maintenance: $270/month</li>
        </ul>
      </div>
      <h3 class="my-4 fw-semibold text-white">Seo Services</h3>
      <div class="row">
        <div class="col-md-6 col-lg-4 mb-4 " data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3 ">
              <h4 class="card-title">Basic SEO Setup</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>3 Pages Optimized – $200</li>
                <li>Includes keyword integration, title/meta setup, image alt tags</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Full Website SEO</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Up to 10 Pages – $450</li>
                <li>Keyword Research, Metadata, Image Optimization, URL Structure, Internal Linking</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Ongoing SEO Management</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Monthly SEO Maintenance – $270/month</li>
                <li>Includes keyword tracking, rank monitoring, content optimization</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <h3 class="my-4 fw-semibold text-white">Backlink Building</h3>
      <div class="row">
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Starter Backlink Pack – $175</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>10 High-DA Backlinks (mix of contextual, directory, blog comments)</li>
                <li>Niche-relevant and white-hat only</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Growth Backlink Pack – $295</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>25 High-DA Backlinks</li>
                <li>Includes guest posts, citations, article submissions</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Premium Authority Pack – $550</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>50+ High-Quality Backlinks</li>
                <li>Custom strategy, outreach-based links, DA 50+</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="bg-light py-5 service-section">
  <div class="container">

    <!-- SOCIAL & WEB SERVICES -->
    <div class="mb-5">
      <h2 class="mb-5 fw-semibold text-center">📱 Social Media & Web</h2>
      <div class="row">
        <div class="col-md-6 mb-4 " data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Social Media Management</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>1 Platform (3 posts/week) – $150/month</li>
                <li>3 Platforms (3–4 posts/week each) – $350/month</li>
                <li>Add-on: Monthly Strategy Report – +$50</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6  mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Email Marketing / Video Blast</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Design + Send to 1,000 contacts – $125</li>
                <li>Video Email Setup – $150</li>
                <li>Monthly Campaign (3 sends) – $250</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6  mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Web Development</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>One-page Landing Site – $200</li>
                <li>3–5 Page Business Site – $400</li>
                <li>Full Custom Website (up to 10 pages) – From $600</li>
                <p class="fw-semibold">Add-on: eCommerce Setup – +$150</p>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6  mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Web Hosting</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li> Basic Hosting Plan – $75+/year</li>
                <li>With Security & Backup – $100+/year</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- APP DESIGN -->
    <div class="mb-5">
      <h2 class="mb-5 fw-semibold text-center">📲 App & UI/UX Design</h2>
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Mobile App UI Mockup</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>3–5 Screens – $150</li>
                <li>6–10 Screens – $250</li>
                <li>Add-on: Interactive Prototype – +$75</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">App Development (Basic MVP)</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Pricing starts at $800+ (quote-based)</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<section class="pledge py-5 service-section">
  <div class="container">

    <!-- LEAD GEN & PRINT -->
    <div class="mb-5">
      <h2 class="mb-4 fw-semibold text-white text-center">📤 Lead Generation & Print Marketing</h2>
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Business Contact List (B2B or B2C)</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>200 Leads – $115 </li>
                <li>500 Leads – $210</li>
                <li>1,000 Leads – $350</li>
                <p class="fw-semibold"> Custom targeting available (industry, location, role)</p>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-5 mb-4" data-aos="flip-left">
          <div class="membership-cards h-100 shadow rounded-4">
            <div class="card h-100 p-3">
              <h4 class="card-title">Direct Mail Postcards</h4>
              <ul class="list-unstyled ps-3 my-3 text-start">
                <li>Design Only – $120</li>
                <li>Design + List Targeting – $215 & up</li>
                <li>Print & Mail Coordination – Quote-Based (starts at $250 for 500 pcs)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ADDITIONAL SERVICES -->
    <div class="mb-5 welcome">
      <h2 class="mb-3 fw-semibold text-white">🎨 Additional Services</h2>
      <ul class="ps-0">
        <li>Logo Animation: $75+</li>
        <li>Script Writing: $40–$75</li>
        <li>Voiceover: $100 (per 60 sec)</li>
        <li>Social Graphics/Templates: $50+</li>
      </ul>
    </div>

    <!-- PAYMENT INSTRUCTIONS -->
    <div class="text-center text-white">
      <h4 class="mb-2">✅ Payment Options</h4>
      <p>Cash App: <strong>$Zaecepe</strong><br> Zelle: <strong>zae&#64;zaecepe.com</strong></p>
      <p><em>Include service name in payment note (e.g., "Whiteboard – 60 sec" or "SMM – 3 platforms")</em></p>
    </div>

  </div>
</section>